var _defs, _path, _path2, _circle, _rect, _rect2, _rect3, _path3, _polygon, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polyline, _path11, _polygon2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _polyline2, _path19, _polygon3, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _polyline3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuppliers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193 187.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-2{fill:none;stroke-width:4px;}.cls-2,.cls-3{stroke:#fff;stroke-miterlimit:10;}.cls-3{stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-202.69,400.3s-2.12,5.38-5.45,7c-15.89,7.68-31.87,9.53-47-.25-2.95-1.92-5.43-4.76-5.11-6.74,1.4-8.74,4.07-14.4,10.34-19.7a4.26,4.26,0,0,1,5.24-.09,22.78,22.78,0,0,0,13.34,4.29A22.74,22.74,0,0,0-217.23,380a3.06,3.06,0,0,1,3.78.06C-206.75,385.3-200.66,398-202.69,400.3Z",
    transform: "translate(324.96 -333.97)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-213.41,361a17.71,17.71,0,0,1-6.92,14.07,17.68,17.68,0,0,1-10.83,3.68A17.81,17.81,0,0,1-242.1,375a17.73,17.73,0,0,1-6.82-14,17.75,17.75,0,0,1,17.75-17.74A17.75,17.75,0,0,1-213.42,361Z",
    transform: "translate(324.96 -333.97)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 92.65,
    cy: 41.35,
    r: 39.35
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -276.85,
    y: 398.12,
    width: 3.56,
    height: 60.5,
    rx: 1.78,
    transform: "translate(540.5 -41.5) rotate(41.81)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -188.73,
    y: 396.41,
    width: 3.56,
    height: 60.5,
    rx: 1.78,
    transform: "translate(283.11 535.34) rotate(138.19)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -230.65,
    y: 410.83,
    width: 3.47,
    height: 38.5,
    rx: 1.74,
    transform: "translate(-132.87 526.19) rotate(-180)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-244.38,482.16l0,.07,0,0Z",
    transform: "translate(324.96 -333.97)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.04 158.14 95.04 187.14 69 173.21 69 144.21 95.04 158.14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-226,492v.09a.14.14,0,0,1,.06-.12Z",
    transform: "translate(324.96 -333.97)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-226,492v.09a.14.14,0,0,1,.06-.12Z",
    transform: "translate(324.96 -333.97)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-200,477.71v28.66a.13.13,0,0,1-.07.12l-25.78,14.38a.1.1,0,0,1-.13,0,.1.1,0,0,1-.06-.1V492.11a.14.14,0,0,1,.06-.12l25.51-14.23,0,0,.24-.13a.08.08,0,0,1,.06,0l.07,0A.09.09,0,0,1-200,477.71Z",
    transform: "translate(324.96 -333.97)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-227.91,488.6a.14.14,0,0,1-.15,0l-12.09-6.46-.06,0,12.19,6.52a.88.88,0,0,1,.17-.12Z",
    transform: "translate(324.96 -333.97)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-227.91,488.6a.14.14,0,0,1-.15,0l-12.09-6.46-.06,0,12.19,6.52a.88.88,0,0,1,.17-.12Z",
    transform: "translate(324.96 -333.97)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-218.36,465.49l-25.9,14.45-9.32-5a.12.12,0,0,1-.08-.13c0-.1,0-.13.07-.14L-228,460.41l.07,0a.1.1,0,0,1,.07,0Z",
    transform: "translate(324.96 -333.97)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-202.26,474.19a.07.07,0,0,1,0,.05.06.06,0,0,1,0,0,.08.08,0,0,1,0,0l0,0-25.51,14.23-.06,0a.14.14,0,0,1-.15,0l-12.09-6.46,25.89-14.45,11.92,6.37A.13.13,0,0,1-202.26,474.19Z",
    transform: "translate(324.96 -333.97)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "82.63 148.26 82.67 148.23 82.73 148.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-176.38,482.16l0,.07,0,0Z",
    transform: "translate(324.96 -333.97)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "163.04 158.14 163.04 187.14 137 173.21 137 144.21 163.04 158.14"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-158,492v.09a.14.14,0,0,1,.06-.12Z",
    transform: "translate(324.96 -333.97)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-158,492v.09a.14.14,0,0,1,.06-.12Z",
    transform: "translate(324.96 -333.97)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-132,477.71v28.66a.13.13,0,0,1-.07.12l-25.78,14.38a.1.1,0,0,1-.13,0,.1.1,0,0,1-.06-.1V492.11a.14.14,0,0,1,.06-.12l25.51-14.23,0,0,.24-.13a.08.08,0,0,1,.06,0l.07,0A.09.09,0,0,1-132,477.71Z",
    transform: "translate(324.96 -333.97)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-159.91,488.6a.14.14,0,0,1-.15,0l-12.09-6.46-.06,0,12.19,6.52a.88.88,0,0,1,.17-.12Z",
    transform: "translate(324.96 -333.97)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-159.91,488.6a.14.14,0,0,1-.15,0l-12.09-6.46-.06,0,12.19,6.52a.88.88,0,0,1,.17-.12Z",
    transform: "translate(324.96 -333.97)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-150.36,465.49l-25.9,14.45-9.32-5a.12.12,0,0,1-.08-.13c0-.1,0-.13.07-.14L-160,460.41l.07,0a.1.1,0,0,1,.07,0Z",
    transform: "translate(324.96 -333.97)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-134.26,474.19a.07.07,0,0,1,0,.05.06.06,0,0,1,0,0,.08.08,0,0,1,0,0l0,0-25.51,14.23-.06,0a.14.14,0,0,1-.15,0l-12.09-6.46,25.89-14.45,11.92,6.37A.13.13,0,0,1-134.26,474.19Z",
    transform: "translate(324.96 -333.97)"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "146.63 148.26 146.67 148.23 146.73 148.2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-313.38,482.16l.05.07,0,0Z",
    transform: "translate(324.96 -333.97)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.04 158.14 26.04 187.14 0 173.21 0 144.21 26.04 158.14"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-295,492v.09a.14.14,0,0,1,.06-.12Z",
    transform: "translate(324.96 -333.97)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-295,492v.09a.14.14,0,0,1,.06-.12Z",
    transform: "translate(324.96 -333.97)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-269,477.71v28.66a.13.13,0,0,1-.07.12l-25.78,14.38a.1.1,0,0,1-.13,0,.1.1,0,0,1-.06-.1V492.11a.14.14,0,0,1,.06-.12l25.51-14.23,0,0,.24-.13a.08.08,0,0,1,.06,0l.07,0A.09.09,0,0,1-269,477.71Z",
    transform: "translate(324.96 -333.97)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-296.91,488.6a.14.14,0,0,1-.15,0l-12.09-6.46-.06,0,12.19,6.52a.88.88,0,0,1,.17-.12Z",
    transform: "translate(324.96 -333.97)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-296.91,488.6a.14.14,0,0,1-.15,0l-12.09-6.46-.06,0,12.19,6.52a.88.88,0,0,1,.17-.12Z",
    transform: "translate(324.96 -333.97)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-287.36,465.49l-25.9,14.45-9.32-5a.12.12,0,0,1-.08-.13c0-.1,0-.13.07-.14L-297,460.41l.07,0a.1.1,0,0,1,.07,0Z",
    transform: "translate(324.96 -333.97)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-271.26,474.19a.07.07,0,0,1,0,.05.06.06,0,0,1,0,0l0,0,0,0-25.51,14.23-.06,0a.14.14,0,0,1-.15,0l-12.09-6.46,25.89-14.45,11.92,6.37A.13.13,0,0,1-271.26,474.19Z",
    transform: "translate(324.96 -333.97)"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "11.63 148.26 11.67 148.23 11.73 148.2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppliers);
export default __webpack_public_path__ + "static/media/Suppliers.3f82b9dd1c1910b2903dd7e8b784afe9.svg";
export { ForwardRef as ReactComponent };